<template>
  <div>
    <el-input
      class="com-search"
      v-model="searchVal"
      size="small"
      :placeholder="$t('layoutView.headSearchPlaceholder')"
      @blur="handleSearchQuery"
      style="width: 14.625rem; height: 2rem;font-size: 0.875rem;"
    >
      <i
        class="el-icon-search search-btn"
        slot="append"
        @click="handleSearchQuery"
      >
      </i>
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    placeholderText: {
      type: String,
      default: "请输入内容",
    },
  },
  data() {
    return {
      searchVal: "",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    handleSearchQuery() {
      this.$emit("searchQuery", this.searchVal);
    },
  },
  components: {},
};
</script>

<style lang="scss">
.com-search {
  width: 14.625rem;
  height: 2rem;
  .el-input__inner {
    width: 14.625rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 0.25rem;
    border: 1px solid #f9f2eb;
  }
  .el-input-group__append {
    width: 2.25rem;
    height: 2.25rem;
    line-height: 2.25rem;
    padding: 0 .625rem;
    background-color: #e8ab75;
    border-radius: 0.1875rem;
    margin-right: -0.25rem;
    color: #fff;
    cursor: pointer;
    font-size: 1.5rem;
  }
}
</style>
